import { styled } from "@mui/material/styles";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import FormTitle from "../../../common/js/components/FormTitle";

const StyledResizeComment = styled(BSInput)(({ theme }) => ({
    "& textarea": {
        resize: "vertical",
    },
}));

const ListingCommentBlock = (props) => {
    const { data, disableInputs, errors, handleInputChange, showFormTitle } = props;
    return (
        <React.Fragment>
            {showFormTitle && <FormTitle title="Listing Comments" />}
            <StyledResizeComment
                id="listingCommentsMember"
                label="Internal Comments"
                placeholder="Comments entered here are only visible inside KMConnect."
                error={errors.listingCommentsMember}
                value={data.listingCommentsMember}
                disabled={disableInputs}
                multiline
                rows={5}
                onChange={(e) => handleInputChange("listing." + e.target.id, e.target.value)}
            />
            <StyledResizeComment
                id="listingCommentsPublic"
                label="Public Comments"
                placeholder="Comments entered here PUBLIC and will be VISIBLE on kidder.com, reports, and excel exports."
                error={errors.listingCommentsPublic}
                value={data.listingCommentsPublic}
                multiline
                disabled={disableInputs}
                rows={5}
                onChange={(e) => handleInputChange("listing." + e.target.id, e.target.value)}
            />
        </React.Fragment>
    );
};

export default ListingCommentBlock;
